import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DataTable from "react-data-table-component";
import Select from "react-select";

import { API_BASE_URL } from "../../../config";

const Designation = ({ fixNavbar }) => {
  /* ---------------- STATE ---------------- */
  const [table, setTable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [companies, setCompanies] = useState([]);
  const [departments, setDepartments] = useState([]);

  const [formData, setFormData] = useState({
    designation_name: "",
    department_id: "",
    company_id: "",
    man_power: "",
  });

  const [user, setUser] = useState({
    designation_id: "",
    designation_name: "",
    department_id: "",
    man_power: "",
  });

  /* ---------------- FETCH DATA ---------------- */
  const fetchDesignations = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/Designation_list`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });
      setTable(res.data.data.Designation || []);
    } catch {
      toast.error("Failed to load designations");
    }
    setLoading(false);
  };

  const fetchCompanies = async () => {
    const res = await axios.get(`${API_BASE_URL}/all_companys`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    setCompanies(res.data.data.all_employee || []);
  };

  const fetchDepartments = async () => {
    const res = await axios.get(`${API_BASE_URL}/all_department`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    setDepartments(res.data.data.all_dept || []);
  };

  useEffect(() => {
    fetchDesignations();
    fetchCompanies();
    fetchDepartments();
  }, []);

  /* ---------------- FILTER ---------------- */
  const filteredData = table.filter((item) =>
    `${item.designation_name} ${item.department_name}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  /* ---------------- ADD ---------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API_BASE_URL}/add_designation`, formData, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });
      if (res.data.status === "success") {
        toast.success(res.data.message);
        fetchDesignations();
        setFormData({
          designation_name: "",
          department_id: "",
          company_id: "",
          man_power: "",
        });
      } else toast.error(res.data.message);
    } catch {
      toast.error("Add failed");
    }
  };

  /* ---------------- EDIT ---------------- */
  const handleUpdate = async (id) => {
    const res = await axios.get(`${API_BASE_URL}/showdesignation/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    setUser(res.data);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${API_BASE_URL}/updatedesignation`,
        user,
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );
      if (res.data.status === "success") {
        toast.success(res.data.message);
        fetchDesignations();
        window.$("#exampleEditModal").modal("hide");
      } else toast.error(res.data.message);
    } catch {
      toast.error("Update failed");
    }
  };

  /* ---------------- DATATABLE ---------------- */
  const columns = [
    { name: "S.No", selector: (row, i) => i + 1, width: "80px" },
    { name: "Designation", selector: (row) => row.designation_name, sortable: true },
    { name: "Department", selector: (row) => row.department_name, sortable: true },
    { name: "Man Power Needed", selector: (row) => row.man_power, center: true },
    { name: "Man Power Available", selector: (row) => row.man_available, center: true },
    {
      name: "Action",
      cell: (row) => (
        <button
          className="btn btn-icon btn-sm"
          data-toggle="modal"
          data-target="#exampleEditModal"
          onClick={() => handleUpdate(row.designation_id)}
        >
          <i className="fa fa-edit" />
        </button>
      ),
      ignoreRowClick: true,
      button: true,
    },
  ];

  /* ---------------- RENDER ---------------- */
  return (
    <>
      <ToastContainer position="bottom-right" />

      <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
        <div className="container-fluid">

          {/* ADD DESIGNATION */}
          <div className="card mb-4">
            <div className="card-header">
              <h3 className="card-title">Add Designation</h3>
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row align-items-end">
                  <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-3">
                    <label>Company</label>
                    <Select
                      classNames={{
                        control: () => "required-select required-tooltip",
                      }}
                      className="react-select"
                      classNamePrefix="rs"
                      options={companies}
                      onChange={(s) =>
                        setFormData({ ...formData, company_id: s.company_id })
                      }
                    />
                  </div>

                  <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-3">
                    <label>Department</label>
                    <Select
                      classNames={{
                        control: () => "required-select required-tooltip",
                      }}
                      className="react-select"
                      classNamePrefix="rs"
                      options={departments}
                      onChange={(s) =>
                        setFormData({ ...formData, department_id: s.value })
                      }
                    />
                  </div>

                  <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-3 required-tooltip">
                    <label>Designation </label>
                    <input
                      className="form-control required-input"
                      value={formData.designation_name}
                      placeholder="Designation"
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          designation_name: e.target.value.replace(/[^A-Za-z\s]/g, ""),
                        })
                      }
                    />
                  </div>

                  <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-3 required-tooltip">
                    <label>Man Power</label>
                    <input
                      type="number"
                      className="form-control required-input"
                      value={formData.man_power}
                      placeholder="Man power"
                      onChange={(e) =>
                        setFormData({ ...formData, man_power: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-xl-2 col-lg-2 col-md-12 col-sm-12 mb-3">
                    <button className="btn btn-primary w-100">Save</button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* LIST */}
          <div className="card">
            <div className="card-header d-flex justify-content-between">
              <h3 className="card-title" style={{ color: "#e96827" }}>
                Designation List
              </h3>

              <div className="d-flex">


                <input
                  className="form-control form-control-sm"
                  style={{ width: 200 }}
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <div className="card-body">
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                paginationPerPage={itemsPerPage}
                highlightOnHover
                striped
                responsive
                persistTableHead
              />
            </div>
          </div>
        </div>
      </div>

      {/* EDIT MODAL */}
      <div className="modal fade" id="exampleEditModal">
        <div className="modal-dialog">
          <form onSubmit={handleEditSubmit}>
            <div className="modal-content">
              <div className="modal-header">
                <h5>Edit Designation</h5>
                <button className="close" data-dismiss="modal">×</button>
              </div>
              <div className="modal-body">
                <input
                  className="form-control mb-2 required-input"
                  value={user.designation_name}
                  onChange={(e) =>
                    setUser({ ...user, designation_name: e.target.value.replace(/[^A-Za-z\s]/g, "") })
                  }
                />

                <Select classNames={{
                  control: () => "required-select required-tooltip"
                }}
                  className="react-select"
                  classNamePrefix="rs"
                  options={departments}
                  value={
                    departments.find((d) => d.value === user.department_id) || null
                  }
                  onChange={(s) =>
                    setUser({ ...user, department_id: s.value })
                  }
                />

                <input
                  type="number"
                  className="form-control mt-2 required-input"
                  value={user.man_power}
                  onChange={(e) =>
                    setUser({ ...user, man_power: e.target.value })
                  }
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" data-dismiss="modal">
                  Close
                </button>
                <button className="btn btn-primary">Save</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* FIX SELECT HEIGHT */}
      <style>
        {`
          .rs__control {
            min-height: 38px !important;
            height: 38px !important;
          }
          .rs__value-container {
            padding: 0 8px !important;
          }
          .rs__input-container {
            margin: 0 !important;
            padding: 0 !important;
          }
        `}
      </style>
    </>
  );
};

const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
});

export default connect(mapStateToProps)(Designation);
